import { optionSubcategory_handling } from './handlingSubCategory.locstring.json';
import { DynamicEmailOption } from 'owa-dynamic-email-option';
import InlineTranslationOption from 'owa-inline-translation-option/lib/InlineTranslationOption';
import { initMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import MarkAsReadOption from 'owa-mark-as-read-option/lib/MarkAsReadOption';
import MessageOption from 'owa-message-option/lib/MessageOption';
import { OptionSubCategory } from 'owa-options-core';
import ReadReceiptsOption from 'owa-read-receipts-option/lib/ReadReceiptsOption';
import { trace } from 'owa-trace';

let handlingSubCategory: OptionSubCategory = {
    key: 'handling',
    titleStringKey: optionSubcategory_handling,
    options: [
        MessageOption,
        MarkAsReadOption,
        ReadReceiptsOption,
        InlineTranslationOption,
        DynamicEmailOption,
    ],
    onSelected: () => {
        return loadMailboxJunkEmailConfiguration();
    },
};

export default handlingSubCategory;

async function loadMailboxJunkEmailConfiguration(): Promise<boolean> {
    try {
        await initMailboxJunkEmailConfiguration();
        return true;
    } catch (e) {
        trace.warn(e.message || 'loadMailboxJunkEmailConfiguration failed');
        return false;
    }
}
